import styled from "styled-components";
import { theme } from "../../theme";
import Small from "./typography/Small";

interface Props {
  rating: string;
}

const Badge = styled.div<{ $color: string }>`
  background-color: ${(props) => props.$color};
  color: white;
  padding: 4px 8px;
  border-radius: 12px;
`;

const CreditRatingBadge: React.FC<Props> = ({ rating }) => {
  const getColorForRating = (rating: string) => {
    switch (rating) {
      case "AAA":
        return theme.colors.success;
      case "AA":
        return theme.colors.success20;
      case "A":
        return theme.colors.success20;
      case "BBB":
        return theme.colors.primary60;
      case "BB":
        return theme.colors.primary60;
      case "B":
        return theme.colors.warning;
      case "CCC":
        return theme.colors.warning;
      case "CC":
        return theme.colors.warning;
      case "C":
        return theme.colors.errorDark;
      case "D":
        return theme.colors.error;
      default:
        return theme.colors.black;
    }
  };

  return (
    <Badge $color={getColorForRating(rating)}>
      <Small fontweight={600} color="white">
        {rating}
      </Small>
    </Badge>
  );
};

export default CreditRatingBadge;
